module.exports = __webpack_public_path__ + "static/media/Nidoran♀_gaussian2.b826091b.png";